import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GcTextComponent } from '@ip-only/front-end-library';
import { ChangelogEntry } from '../changelog.entities';

@Component({
  selector: 'app-changelog-entry-card',
  imports: [GcTextComponent],
  templateUrl: './changelog-entry-card.component.html',
  styleUrl: './changelog-entry-card.component.scss',
})
export class ChangelogEntryCardComponent {
  private readonly sanitizer = inject(DomSanitizer);

  entry = input.required<ChangelogEntry>();
  safeVideoUrl = computed<SafeResourceUrl | null>(() => {
    const url = this.entry().videoUrl;

    if (!url) return null;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  });
}
